import { css } from '@emotion/react'

export const fillHeightCss = css`
  height: 100vh;
  height: -webkit-fill-available;
`

export const fillMinHeightCss = css`
  min-height: 100vh;
  min-height: -webkit-fill-available;
`
